import React, { useLayoutEffect } from 'react';
import { StyleSheet, View } from 'react-native';
import Animated, { useAnimatedScrollHandler } from 'react-native-reanimated';
import { AppView } from 'design-system/AppView';
import StatusBar from 'design-system/StatusBar';
import withAnimatedNavigationHeader from 'design-system/hoc/withAnimatedNavigationHeader';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useMarginBottom } from 'hooks/useMarginBottom';
import HelpScreenButton from 'features/help/components/HelpScreenButton';
import { HELP_ARTICLES_KEY } from 'features/help/constants';
import { AccountAndPreference } from './AccountAndPreference';
import { AboutAndImportantStuff } from './AboutAndImportantStuff';
import { AppVersion } from './AppVersion';
import { isWeb } from '../../../constants';
const sections = [AccountAndPreference, AboutAndImportantStuff];
const strings = {
    headerTitle: 'Settings',
};
const keyExtractor = (item) => item.name;
const renderItem = ({ item: Section }) => <Section />;
export const SettingsScreen = withAnimatedNavigationHeader(({ scrollY, navigation }) => {
    useLayoutEffect(() => {
        navigation.setOptions({
            headerRight: () => (<HelpScreenButton articlesKey={HELP_ARTICLES_KEY.SETTINGS}/>),
        });
    }, []);
    const scrollHandler = useAnimatedScrollHandler((handle) => {
        // eslint-disable-next-line no-param-reassign
        scrollY.value = handle.contentOffset.y;
    });
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const contentContainerStyle = useMarginBottom('paddingBottom', undefined, paddingHorizontalStyle);
    return (<AppView type="secondary" withFrame={false}>
        <StatusBar barStyle="dark-content" animated/>
        <View style={styles.flex}>
          <Animated.FlatList data={sections} scrollEventThrottle={16} renderItem={renderItem} onScroll={scrollHandler} keyExtractor={keyExtractor} ListFooterComponent={AppVersion} contentContainerStyle={contentContainerStyle}/>
        </View>
      </AppView>);
}, ({ colors }) => ({
    title: strings.headerTitle,
    headerColorOutputRange: [
        colors.background.dark,
        colors.cards.onDark,
    ],
}));
const styles = StyleSheet.create({
    flex: {
        flex: 1,
    },
});
